import { SdkContext } from '../internal'

/**
 * F-110: the platform socket's ticket. Any role of the community of
 * `X-CommunityId`, with the chat on or off; 503 when the server has no real
 * time (no Redis), and the app keeps reading the routes.
 */

export interface RealtimeTicket {
  ticket: string
  expiresIn?: number
  /** `/api/realtime/socket` */
  path?: string
  /** `['memberfy-realtime', ticket]`, the WebSocket subprotocols in this order (SEC-196: never in the URL). */
  protocols?: string[]
  pingIntervalMs?: number
  maxRooms?: number
}

export class RealtimeResource {
  constructor(private ctx: SdkContext) {}

  /** A single-use ticket (60 s) for `wss://<api>/api/realtime/socket`. */
  async ticket(): Promise<RealtimeTicket> {
    return this.ctx.call({ httpMethod: 'POST', path: '/realtime/ticket', hasBody: true }, { body: {} })
  }
}
